import { z } from 'zod'
import {
	CreateBrokeFlexMessageItemDtoType,
	CreateBrokeFlexMessageItemDtoEligibilityType,
} from '../../types'

export const notificationItemSchema = z.object({
	type: z.nativeEnum(CreateBrokeFlexMessageItemDtoType),
	order: z.number().min(0),
	eligibilityType: z.nativeEnum(CreateBrokeFlexMessageItemDtoEligibilityType),
	minValue: z.number().optional(),
	displayName: z.string().min(1, 'กรุณากรอกชื่อที่แสดง'),
	icon: z.string().default('🎁'),
	description: z.string().optional(),
	message: z.string().optional(),
	imageUrl: z.string().optional(),
	promotionId: z.string().optional(),
	couponCode: z.string().optional(),
	actionUrl: z.string().optional(),
	enabled: z.boolean().default(true),
})

export type NotificationItemFormData = z.infer<typeof notificationItemSchema>
